export default "__VITE_ASSET__CNC_XIdh__"